import { DiagnocoinLedgerEntryType } from 'protocol/api/billing_new/dto_diagnocoin_new_pb';

import { LONG_DATE_FORMAT } from '@/shared/config';

import { DiagnocoinHistoryFilter } from './types';

export const DIAGNOCOIN_HISTORY_FILTER_TYPES: Record<
  DiagnocoinHistoryFilter,
  readonly DiagnocoinLedgerEntryType[]
> = {
  [DiagnocoinHistoryFilter.all]: [],
  [DiagnocoinHistoryFilter.purchases]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeCredit,
  ],
  [DiagnocoinHistoryFilter.deductions]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeReserve,
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeExpire,
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeAdjustment,
  ],
  [DiagnocoinHistoryFilter.refunds]: [
    DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeRelease,
  ],
};

export const DIAGNOCOIN_HISTORY_PAGE_SIZE = 50;

export const DIAGNOCOIN_DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  ...LONG_DATE_FORMAT,
  hour: '2-digit',
  minute: '2-digit',
};

export const DIAGNOCOIN_EXPIRY_HINT_MONTHS = 3;
